<template>
  <button class="cpnt-button btn" :is="cpntTag" v-show="cpntMostrar"
  :id="cpntId"
  :class="cpntClass"
  :disabled='cpntStatus !== "" || cpntDisabled !== false'
  @click="cpntButtonOnClick"
  @mousedown="cpntButtonClickMouseDown"
  :key="cpntStatus"
  :tabindex="cpntTabIndex"
  ref="button">
    <!-- SETA O STATUS DO BOTÃO -->
    <App-Status :cpntStatus="cpntStatus" v-if="cpntStatus !== ''"></App-Status>

    <!-- SETA O SLOT DO BOTÃO -->
    <template v-else-if="cpntStatus === ''">
      <slot>
        <!-- SETA O ICONE A SER UTILIZADO -->
        <App-Icone v-if="cpntIcone !== ''" :cpntTipo="cpntIcone"></App-Icone>

        <!-- SETA O TEXTO DO BOTÃO -->
        <span v-if="cpntTexto !== ''" v-html="cpntTexto"></span>
      </slot>
    </template>
  </button>
</template>

<style>
  .cpnt-button > .cpnt-status,
  .cpnt-button > span > .cpnt-status {
    width: 100%;
  }
</style>

<script>
  export default {
    props: {
      cpntTag: {
        required: false,
        type: String,
        default: function () {
          return 'button'
        }
      },
      cpntStatus: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // VERIFICA SE GEROU UM ID VALIDO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-button-' + (Math.floor(Math.random() * 8888) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntClass: {
        required: false,
        default: function () {
          return 'btn-default btn-sm'
        }
      },
      cpntTexto: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntIcone: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntExplica: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntDisabled: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      },
    },
    data: function () {
      return {
        statusGeral: '',
        button: ''
      }
    },
    mounted: function () {
      // SETA O CAMPO BUTTON
      this.button = $(this.$refs.button)

      // CHAMA A FUNÇÃO PARA CRIAR O QTIP DO BOTÃO
      this.cpntButtonCriarQtip()

    },
    destroyed: function () {
      this.button.qtip('destroy', true)
    },
    methods: {
      cpntButtonOnClick: function (event) {
        if (this.cpntDisabled === false) {
          this.$emit('onClick', this.cpntId, event)
        }
      },
      cpntButtonClickMouseDown: function (event) {
        // PARA O PROCESSO DE CLICK
        event.stopPropagation()
        event.preventDefault()

        // VERIFICA SE O CONTROL ESTÁ PRECIONADO
        if (event.which === 2) {
          // SETA O CLICK NO SCROLL
          this.$store.commit('SET_BUTTON_CLICK_SCROLL', this.cpntId)

          // CHAMA A FUNÇÃO PARA DAR O CLICK NO BUTTON
          this.cpntButtonOnClick(event)
        }
      },
      cpntButtonCriarQtip: function () {
        // DESTROI O QTIP SE ELE EXISITR
        this.button.qtip('destroy', true)

        // VERIFICA SE TEM QTIP PARA COLOCAR
        if ([ '', null, undefined ].indexOf(this.cpntExplica) === -1 && [ '', null, undefined ].indexOf(this.cpntExplica.mensagem) === -1) {
          setTimeout(() => {
            // SETA AS CHAVES INICIAIS
            var vetor = {
              mensagem: '',
              titulo: '',
              posicaoMy: 'top left',
              posicaoAt: 'bottom right',
              classes: 'rf-qtip cpnt-qtip-button' + ([ '', null, undefined ].indexOf(this.cpntExplica.class) === -1 ? (' ' + this.cpntExplica.class) : '')
            }
  
            // SETA OS VALOORE E PADROES PARA O QTIP
            for (var indexC in vetor) {
              vetor[indexC] = [ '', null, undefined ].indexOf(this.cpntExplica[indexC]) !== -1 ? vetor[indexC] : this.cpntExplica[indexC]
            }
  
            // VERIFICA SE TEM QUE CONVERTER A CHAVE MESSAGE
            if (Array.isArray(vetor.mensagem) === true) {
              vetor.mensagem = vetor.mensagem.join('<br/>')
            }
    
            // APLICA O QTIP NO CAMPO DESEJADO
            this.button.qtip({
              content: {
                text: vetor.mensagem,
                title: vetor.titulo
              },
              position: {
                my: vetor.posicaoMy,
                at: vetor.posicaoAt
              },
              style: { classes: vetor.classes }
            })
          }, 0)
        }
      }
    },
    watch: {
      cpntExplica: function () {
        this.cpntButtonCriarQtip()
      }
    }
  }
</script>
